import { ApplicationConfig } from '@angular/core';
import { provideRouter, withDebugTracing } from '@angular/router';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';

import { routes } from './app.routes';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { provideStore } from '@ngrx/store';
import { reducers } from './reducers';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { EditorEffects } from './editor/store/editor.effects';
import { MessageService } from 'primeng/api';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { UserEffects } from './users/store/user.effects';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { environment } from '../environments/environment';
import { provideHighlightOptions } from 'ngx-highlightjs';

console.log(environment.firebaseConfig)
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(),
    HttpClientModule,
    provideAuth(() => getAuth()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideAnalytics(() => getAnalytics()),
    { provide: FIREBASE_OPTIONS, useValue: environment.firebaseConfig},
    provideStore(reducers),
    provideEffects([EditorEffects, UserEffects]),
    provideStorage(() => getStorage()),
    provideHighlightOptions({
      coreLibraryLoader: () => import('highlight.js/lib/core'),
      languages: {
        luau: () => import('highlightjs-luau'),
        lua: () => import('highlight.js/lib/languages/lua')
      }
    }),
    MessageService,
    ...!environment.production ? [provideStoreDevtools({ maxAge: 50, trace: true })] : []
  ],
};

